<template>
  <modify-apply-block
    :column-list="columnList"
    ref="worker_certificate_doctor_qua_p"
    :display="display"
    :form-parms-add="formParmsAdd"
    :table-actions="tableActions"
    :dataFileParm="{pDirPath: '/worker_certificate/'}"
    :isReal="isReal"
    block-name="职业资格证书"
    :getEdit="getEdit"
    :saveEdit="saveEdit"
    :addEdit="addEdit"
    :init-add-form-data="initAddFormData"
    @completeness="completeness"
    ref-name="worker_certificate_doctor_qua"
    :worker-id="workerId"
    :is-absolut="isAbsolut">
  </modify-apply-block>
</template>

<script>
import ModifyApplyBlock from './modifyApplyBlock'

import {
  workerCertificateRequest
} from '../../../../api'

export default {
  components: {
    ModifyApplyBlock
  },
  props: {
    isReal: {
      type: Boolean,
      default: false
    },
    isAbsolut: {
      type: Boolean,
      default: true
    },
    workerId: {
      type: [String, Number]
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async getEdit () {
      if (this.isReal) {
        let data = await workerCertificateRequest.get({
          type: 'doctor_qua',
          workerId: this.workerId
        })
        return data.map(v => {
          return {
            sourceInfo: v
          }
        })
      } else {
        return await workerCertificateRequest.getEdit({
          type: 'doctor_qua',
          workerId: this.workerId
        })
      }
    },
    async saveEdit (parm) {
      if (this.isReal) {
        if (parm.isDel) {
          return await workerCertificateRequest.del(parm.id)
        } else {
          return await workerCertificateRequest.update(parm.id, parm)
        }
      } else {
        return await workerCertificateRequest.saveEdit(Object.assign({}, parm, {
          dataId: parm.id,
          id: undefined
        }))
      }
    },
    async addEdit (parm) {
      if (this.isReal) {
        return await workerCertificateRequest.add(parm)
      } else {
        return await workerCertificateRequest.addEdit(parm)
      }
    },
    initAddFormData () {
      return {
        workerId: this.workerId,
        type: 'doctor_qua'
      }
    },
    completeness (data) {
      this.$emit('completeness', data)
    },
    async save () {
      await this.$refs['worker_certificate_doctor_qua_p'].save()
    },
    async submit () {
      await this.$refs['worker_certificate_doctor_qua_p'].submit()
    },
    testEdited () {
      return this.$refs['worker_certificate_doctor_qua_p'].testEdited()
    }
  },
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'select',
          selectDatas: this.$store.getters.selectDatas['qualification_certificate_type'],
          label: '证件类型',
          key: 'xlmc'
        },
        {
          type: 'input',
          label: '证书编码',
          key: 'code'
        },
        {
          type: 'input',
          label: '发证机关',
          key: 'issueOrg'
        },
        {
          type: 'input',
          label: '签发人',
          key: 'issueUser'
        },
        {
          type: 'datePicker',
          label: '发证日期',
          key: 'getDate'
        },
        {
          type: 'input',
          label: '毕业学校',
          key: 'gradSchool'
        },
        {
          type: 'input',
          label: '专业',
          key: 'pro'
        },
        {
          type: 'input',
          label: '类别',
          key: 'mType'
        }]
        return data
      }
    },
    tableActions () {
      return [{
        key: 'draft_file',
        label: '扫描件',
        show: (data) => {
          return !data.isDel
        }
      },
      {
        key: 'table-expand-edit',
        label: '修改',
        show: (data) => {
          return !data.isDel
        }
      },
      {
        key: 'del',
        label: '删除',
        show: (data) => {
          return !data.isDel
        }
      },
      {
        key: 'back_del',
        label: '恢复',
        show: (data) => {
          return data.isDel
        }
      }]
    },
    columnList () {
      return [{
        title: '证书类型',
        field: 'xlmc',
        sort: true
      },
      {
        title: '证书编码',
        field: 'code',
        sort: true
      },
      {
        title: '发证机关',
        field: 'issueOrg',
        sort: true
      },
      {
        title: '签发人',
        field: 'issueUser',
        sort: true
      },
      {
        title: '发证日期',
        field: 'getDate',
        sort: true,
        dataType: Date,
        format: (rowData) => {
          return rowData && rowData.getDate ? rowData.getDate.slice(0, 10) : '-'
        }
      },
      {
        title: '毕业学校',
        field: 'gradSchool',
        sort: true
      },
      {
        title: '专业',
        field: 'pro',
        sort: true
      },
      {
        title: '类别',
        field: 'mType',
        sort: true
      },
      {
        title: '扫描件状态',
        field: 'imgStatusText',
        sort: true
      },
      {
        title: '最近更新扫描件时间',
        field: 'imgUploadTime',
        width: 180,
        sort: true,
        dataType: Date
      }]
    }
  }
}
</script>
